import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '@/store/slices/mmsSales.slice'; // Import your action creators
import * as api from '@/services/mmsSales'; // Import your API functions
import { PayloadAction } from '@reduxjs/toolkit';
import { isBoolean } from 'lodash';

import { IApiResponse } from '@/services/mmsSales/mmsSales.types';
import {
  GET_MMS_SALES_ACTION_TYPE,
  GET_MMS_SALES_BY_ORDER_ID_ACTION_TYPE,
} from '@/constant/mmsSales/mmsSales.constants';

// Define action types
export interface GetMmsSalesAction extends PayloadAction<number> {
  type: 'mmsSales/getMmsSales';
}

export interface GetMmsSalesRecordAction extends PayloadAction<{
  orderId: string;
}> {
  type: 'mmsSales/getMmsSalesById';
}

function* getMmsSales(action: GetMmsSalesAction): Generator {
  try {
    const response: any = yield call(api.fetchMmsSales as any, action?.payload);
    if (isValidMmsSalesResponse(response?.data)) {
      yield put(actions.getMmsSalesSuccess(response?.data));
    } else {
      yield put(actions.getMmsSalesFailure(response?.data || 'API error'));
    }
  } catch (error: any) {
    yield put(
      actions.getMmsSalesFailure(
        error?.response?.data || { message: error?.message },
      ),
    );
  }
}

function* getMmsSalesRecordById(action: GetMmsSalesRecordAction): Generator {
  try {
    const response: any = yield call(
      api.fetchMmsSalesRecordByOrderId as any,
      action?.payload,
    );
    if (isValidMmsSalesRecordResponse(response.data)) {
      yield put(actions.getSalesRecordSuccess(response.data));
    } else {
      yield put(actions.getSalesRecordFailure(response.data));
    }
  } catch (error: any) {
    yield put(
      actions.getSalesRecordFailure(
        error?.response?.data || { message: error?.message },
      ),
    );
  }
}

function isValidMmsSalesResponse(response: IApiResponse): boolean {
  return (
    isBoolean(response.success) ||
    response.message === 'Succesfully grabbed orders'
  );
}
function isValidMmsSalesRecordResponse(response: IApiResponse): boolean {
  return (
    isBoolean(response.success) ||
    response.message === 'Succesfully grabbed order'
  );
}

function* mmsSalesSaga(): Generator {
  yield takeLatest<GetMmsSalesAction>(GET_MMS_SALES_ACTION_TYPE, getMmsSales);
  yield takeLatest<GetMmsSalesRecordAction>(
    GET_MMS_SALES_BY_ORDER_ID_ACTION_TYPE,
    getMmsSalesRecordById,
  );
}

export default mmsSalesSaga;
